import classNames from "classnames";
import React, { FunctionComponent, memo } from "react";

import { buildTextColorVariantClassNames, TColorVariant } from "../../style/colorVariants";

export interface ISeparatorProps {
  color?: TColorVariant;
}

export const Separator: FunctionComponent<ISeparatorProps> = memo(props => {
  const baseClass = "separator";
  const colorVariant = props.color || "border-inside";
  return <hr className={classNames(baseClass, buildTextColorVariantClassNames(colorVariant))} />;
});
